// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__list___1UKvp {\n  margin-top: 5px;\n  list-style: inherit;\n  margin-left: 20px;\n}\n\n.css__pre___1dfyJ {\n  width: 100%;\n  overflow: scroll;\n}", ""]);
// Exports
exports.locals = {
	"list": "css__list___1UKvp",
	"pre": "css__pre___1dfyJ"
};
module.exports = exports;
